import React from 'react'
import { GeneralTable } from 'modules/app/styles'
import { ReactComponent as EditIcon } from 'assets/images/icons/edit.svg'
import { getEmail } from '.'

export const Removed = (props) => {
  return (
    <GeneralTable responsive>
      <thead>
        <tr>
          {props.my_membership.user_type === 'admin' && <th></th>}
          <th style={{ minWidth: 150 }}> Email </th>
        </tr>
      </thead>
      <tbody>
        {props.memberList.length === 0 && (
          <tr>
            <td colSpan={2}> No members.</td>
          </tr>
        )}
        {props.memberList.map((member, index) => {
          return (
            <tr key={index} id={`member_${member.id}`}>
              {props.my_membership.user_type === 'admin' && (
                <td>
                  {!!!member.is_active && ''}
                  {!!member.is_active && member.user_id === props.user.id && 'Me'}
                  {!!member.is_active && member.invite_status !== 'owned' && member.user_id !== props.user.id && (
                    <a href='/' onClick={(e) => props.onShowEditMember(e, member)}>
                      <EditIcon />
                    </a>
                  )}
                </td>
              )}
              <td>{getEmail(member)}</td>
            </tr>
          )
        })}
      </tbody>
    </GeneralTable>
  )
}
